<template>
  <tenant-invoice />
</template>

<script>
import TenantInvoice from '@/views/console/invoice/tenantInvoice.vue'

export default {
  name: 'TenantInvoicing',
  components: {
    TenantInvoice
  }
}
</script>
